import categoryApi from '@/api/category.api'

export const categoryService = (function () {
    'use strict'

    /**
   * Devuelve los datos de las categorías
   */
    async function getAll() {
        try {
            const response = await categoryApi.getAll()
            return response.data
        } catch (exception) {
            console.error(exception)
            return false
        }
    }
    /**
   * Devuelve los datos para la tabla del ABM de Categorías
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} headers
   * @param {*} enterpriseIds
   */
    async function findAll(pageSize, pageNumber, headers = false, enterpriseIds) {
        try {
            const response = await categoryApi.findAll(undefined, undefined, headers, enterpriseIds)
            return response.data
        } catch (exception) {
            console.log(exception)
            return {
                data: [],
                headers: []
            }
        }
    }

    /**
     * Devuelve el total de categorías de la collection para el paginador de la tabla del ABM
     */
    async function getTotal(enterpriseIds) {
        try {
            const response = await categoryApi.getTotal(enterpriseIds)
            return response.data
        } catch (exception) {
            console.log(exception)
            return 0
        }
    }

    /**
     * Devuelve una categoría con el id enviado como parámetro
     * @param {*} categoryId
     */
    async function getCategory(categoryId) {
        try {
            const response = await categoryApi.getCategory(categoryId)
            return response.data
        } catch (exception) {
            console.log(exception)
            return false
        }
    }

    /**
     * Devuelve las categorías con el id de empresa enviado como parámetro
     * @param {*} enterpriseId 
     */
    async function getCategoriesByEnterpriseId(enterpriseId) {
        try {
            const response = await categoryApi.getCategoriesByEnterpriseId(enterpriseId)
            return response.data
        } catch (exception) {
            console.error(exception)
            return false
        }
    }

    /**
     * Para validar el nombre
     * Devuelve true si ya está asignado a un flota
     * @param {*} name
     */
    async function validateCategoryName(name) {
        try {
            if (name) {
                const response = await categoryApi.validateCategoryName(name)
                return response.data
            } else {
                return false
            }
        } catch (exception) {
            console.log(exception)
            return false
        }
    }

    /**
     * Para eliminar una categoría
     */
    async function deleteOne(id) {
        const response = await categoryApi.deleteOne(id)
        return response.data
    }

    /**
     * Para eliminación múltiple
     */
    async function deleteMany(ids) {
        const response = await categoryApi.deleteMany(ids)
        return response.data
    }


    /**
     * Crea una nueva categoría en la collection
     * @param {*} category
     * @param {*} selectedZonePoiIds
     */
    async function create(category, selectedZonePoiIds) {
        const response = await categoryApi.create(category, selectedZonePoiIds)
        return response.data
    }

    /**
     *  Actualiza un categoría existente en la collection
     * @param {*} category
     * @param {*} selectedZonePoiIds
     */
    async function update(category, selectedZonePoiIds) {
        const response = await categoryApi.update(category, selectedZonePoiIds)
        return response.data
    }

    return {
        findAll,
        getTotal,
        getCategory,
        validateCategoryName,
        deleteOne,
        deleteMany,
        create,
        update,
        getCategoriesByEnterpriseId,
        getAll
    }
})()